// extracted by mini-css-extract-plugin
export var card = "styles-module--card--96f7c";
export var cardDescription = "styles-module--card-description--9f490";
export var cardIcon = "styles-module--card-icon--cd45e";
export var cardTitle = "styles-module--card-title--6c341";
export var cards = "styles-module--cards--7124e";
export var subtitle = "styles-module--subtitle--d34e1";
export var title = "styles-module--title--e8bbe";
export var wrapper = "styles-module--wrapper--a6083";